export const HIDE_ALL_VIEW = 'HIDE_ALL_VIEW';
export const SHARED_LINK_PASSWORD = 'SHARED_LINK_PASSWORD';
export const SHARED_LINK_NOT_FOUND = 'SHARED_LINK_NOT_FOUND';
export const RESTORE_SHARED_FILE = 'RESTORE_SHARED_FILE';
export const RESTORE_SHARED_FOLDER = 'RESTORE_SHARED_FOLDER';
